function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

import assignStyle from 'css-in-js-utils/lib/assignStyle';
import arrayEach from 'fast-loops/lib/arrayEach';

function resolveResponsiveValues(style, properties, getMediaQueries, props) {
  var _loop = function _loop(property) {
    if (properties[property]) {
      var value = style[property];

      if (Array.isArray(value)) {
        var mediaQueries = getMediaQueries(value, props);

        var _value = _toArray(value),
            defaultValue = _value[0],
            mediaValues = _value.slice(1);

        style[property] = defaultValue;
        arrayEach(mediaQueries.slice(0, mediaValues.length), function (query, index) {
          assignStyle(style, _defineProperty({}, query, _defineProperty({}, property, mediaValues[index])));
        });
      }
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

export default function responsiveValue(getMediaQueries) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (style, type, renderer, props) {
    return resolveResponsiveValues(style, properties, getMediaQueries, props);
  };
}